module.exports = __webpack_public_path__ + "static/media/Making Invoice Templates Available to a Specific Branch.c1908005.png";